import { ITEM_TYPE } from '../Helpers/constants';

// Equipment items. Bonuses are flat additive on hero stats.
// Stat keys must match the stats schema: strength, intelligence, dexterity,
// vitality, maxHealth, maxMana. Flat numbers only — no percentages for now.
export const EQUIPMENT_LIST = {
    woodenSword: {
        id: 'woodenSword',
        type: ITEM_TYPE.WEAPON,
        name: 'Épée en bois',
        icon: '🗡️',
        description: 'Plus solide qu\'on ne le pense. +2 force.',
        price: 30,
        consumable: false,
        stackable: false,
        bonuses: { strength: 2 },
    },
    ironSword: {
        id: 'ironSword',
        type: ITEM_TYPE.WEAPON,
        name: 'Épée de fer',
        icon: '⚔️',
        description: 'Une lame correcte pour combattre. +5 force.',
        price: 120,
        consumable: false,
        stackable: false,
        bonuses: { strength: 5 },
    },
    apprenticeStaff: {
        id: 'apprenticeStaff',
        type: ITEM_TYPE.WEAPON,
        name: 'Bâton d\'apprenti',
        icon: '🪄',
        description: 'Canalise la magie élémentaire. +4 intelligence, +1 mana max.',
        price: 100,
        consumable: false,
        stackable: false,
        bonuses: { intelligence: 4, maxMana: 5 },
    },
    leatherArmor: {
        id: 'leatherArmor',
        type: ITEM_TYPE.ARMOR,
        name: 'Armure de cuir',
        icon: '🦺',
        description: 'Protection légère. +5 PV max.',
        price: 50,
        consumable: false,
        stackable: false,
        bonuses: { maxHealth: 5, vitality: 1 },
    },
    chainMail: {
        id: 'chainMail',
        type: ITEM_TYPE.ARMOR,
        name: 'Cotte de mailles',
        icon: '🛡️',
        description: 'Armure en anneaux de métal. +12 PV max, +2 vitalité.',
        price: 180,
        consumable: false,
        stackable: false,
        bonuses: { maxHealth: 12, vitality: 2 },
    },
    leatherCap: {
        id: 'leatherCap',
        type: ITEM_TYPE.HELM,
        name: 'Casque de cuir',
        icon: '⛑️',
        description: 'Une protection minimum pour la tête. +3 PV max.',
        price: 25,
        consumable: false,
        stackable: false,
        bonuses: { maxHealth: 3 },
    },
    strengthRing: {
        id: 'strengthRing',
        type: ITEM_TYPE.ACCESSORY,
        name: 'Anneau de force',
        icon: '💍',
        description: 'Un anneau ancestral. +3 force.',
        price: 80,
        consumable: false,
        stackable: false,
        bonuses: { strength: 3 },
    },
    swiftBoots: {
        id: 'swiftBoots',
        type: ITEM_TYPE.ACCESSORY,
        name: 'Bottes lestes',
        icon: '👢',
        description: 'Vous rendent plus agile. +3 dextérité.',
        price: 80,
        consumable: false,
        stackable: false,
        bonuses: { dexterity: 3 },
    },
};
